module.exports = __webpack_public_path__ + "static/25-5099ed41430b3155cabda4070f67bbd7.jpg";